module.exports = __webpack_public_path__ + "static/acciona-logo-2f8ed774b6304ca64eb8ce826aafef2f.jpeg";